export default {
  name: 'copyReportLink',
  template:
      `<div class="panel">
        <textarea class="copyRepLinkTextBox"
                  ng-click="CopyRepLinkCtrl.copyOnClick($event);"
                  ng-model="CopyRepLinkCtrl.text"
                  readonly="true"
        >
        </textarea>
      </div>`,
  controller: CopyReportLinkController,
  controllerAs: 'CopyRepLinkCtrl',
  bindings: {
    text: '<'
  }
};

/* @ngInject */
function CopyReportLinkController(clipboard, growl) {
  const vm = this;
  vm.copyOnClick = ($event) => {
    $event.target.select();
    if (clipboard.supported) {
      clipboard.copyText($event.target.value);
      growl.info('Copied to clipboard', {
        disableCloseButton: false,
        ttl: 3000
      });
    } else {
      growl.warning('Copy to clipboard not supported in this browser', {
        disableCloseButton: true,
        ttl: 5000
      });
    }
  };
}
